import { Field } from "typegraph";


export class TopicStat {

	@Field()
	public flags: number;

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/TopicStat.ts